
function getTrackingName(requestType) {
  switch (requestType) {
  case 'sales':
    return 'Sales form'
  case 'support':
    return 'Support form'
  default:
    return 'Contact form'
  }
}

export default function pushWizardFormEvent(eventName, incentive, formOptions, fieldValues = {}, stepName = null) {
  const event = {
    event: eventName,
    wizardFormName: getTrackingName(formOptions.requestType),
    wizardFormBrand: formOptions.brand,
    wizardFormFlow: formOptions.requestType,
    wizardFormFleetSize: fieldValues.inseegoFleetFleetSize,
    wizardFormStep: stepName,
    wizardFormIncentive: incentive,
  }
  window.dataLayer.push(event)
}
